import React from "react";
import { routes } from "../../../../../Utils/contstant";
import BoxShadow from "../../../../Common/Components/BoxShadow";
import { useRules } from "../Hooks";
import { FormControlLabel, FormGroup, Switch } from "@mui/material";
import { useLocation, useParams } from "react-router-dom";
const access = require("../../../../../Utils/accses.json");

const EditRole = () => {
  const { toggle, isIn } = useRules();
  const { slug } = useParams();
  let helpAli = [
    {
      label: "مدیریت کاربران",
      routes: ["x6QFbkruZ9GXgBS", "Hf8zLu6tT41WlnW", "iNsQPgRA15hLntU"],
    },
    {
      label: "مدیریت مجموعه ها",
      routes: ["x6QFbkruZ9GXgBS", "Hf8zLu6tT41WlnW", "iNsQPgRA15hLntU"],
    },
  ];
  const routes = [
    {
      label: "ادمین",
      type: "admins",
      routes: [
        {
          label: "داشبورد",
          key: "HCyH3IkLArXwjxf",
        },
        {
          label: "مدیریت فروش",
          key: "sDT0PHOPIQLQ31l",
        },
        {
          label: "ویرایش اطلاعات مجموعه",
          key: "ItiWea3GbSA5ms2",
        },
        {
          label: "ویرایش زمان بندی مجموعه مجموعه",
          key: "C7KTlmRek93Kg4n",
        },
        {
          label: "مدیریت کلاس",
          key: "H0mCn6O1TGIP97t",
        },
        {
          label: "مدیریت مجله",
          key: "SStE6mZ41iRWGoL",
        },
        {
          label: "مدیریت کامنت ها",
          key: "6ioG80a7o2n7AYb",
        },
        {
          label: "مدیریت نقش ها",
          key: "uKQHaNT4qYQnQrR",
        },
        {
          label: "مدیریت کاربران",
          key: "x6QFbkruZ9GXgBS",
        },
        {
          label: "شارژ کیف پول کاربر",
          key: "Hf8zLu6tT41WlnW",
        },
        {
          label: "مدیریت ادمین",
          key: "iNsQPgRA15hLntU",
        },
        {
          label: "مشکلات کاربران",
          key: "7zX3LOwZ6DD42dx",
        },
        {
          label: "درخواست های ثبت مجموعه",
          key: "rn6tcb4i13LcfQc",
        },
        {
          label: "درخواست ها برداشت درآمد",
          key: "yD1aVuyUEsZSNQ5",
        },
        {
          label: "مشاهده قرار داد ها",
          key: "sLNm1s0NaMigJgw",
        },
        {
          label: "ارتباط با ما",
          key: "a4WaRV8ah71AjiD",
        },

        {
          label: "پشتیبانی",
          key: "YodsAZ5wQhqPkb7",
        },
        {
          label: "مدیریت تخفیف ها",
          key: "gB629zLNzAIU50K",
        },
        {
          label: "مدیریت  مناطق",
          key: "kYtTRlW7WMRlUv8",
        },
        {
          label: "مدیریت  تگ ها",
          key: "RlXV7b1gD5lj0bB",
        },
        {
          label: "مدیریت گزارش اشکال",
          key: "1mEVNy0pwIrYQHT",
        },
        {
          label: "تنظیمات کلی",
          key: "gj3vwni0bok9TvQ",
        },
        {
          label: "تنظیمات سایت",
          key: "XkfeidJNH5y6jP3",
        },
        {
          label: "تنظیمات کمپانی",
          key: "9sgoHln0qizHjN8",
        },
        {
          label: "تنظیمات سوالات متداول",
          key: "1LbPNQyoNTfvyT8",
        },
        {
          label: "تنظیمات دسته بندی سوالات متداول",
          key: "1ZwwOJDo2ERSYxI",
        },
        {
          label: "تنظیمات پاداش",
          key: "CRAhIfJ000HmqcD",
        },
        {
          label: "تنظیمات امتیاز دهی",
          key: "ZYhQatFTExHKWBp",
        },
        {
          label: "تنظیمات باشگاه مشتریان",
          key: "Ec3hcij6y5dXSTF",
        },
        {
          label: "تنظیمات ورژن اپ",
          key: "xPoWP1tbzES45ii",
        },
      ],
    },
    {
      label: "مدیر مجموعه",
      type: "users",
      routes: [
        {
          label: "داشبورد",
          key: "otLovXf63uQMvkm",
        },
        {
          label: "مدیریت مجموعه",
          key: "GDEN2LGUws4EZgH",
        },
        {
          label: "مدیریت سفارشات",
          key: "RrHtsx52kXj2HIa",
        },
        {
          label: "برداشت درآمد",
          key: "FZ95t4kxqNjVnsL",
        },

        {
          label: "مدیریت ورزشکاران",
          key: "AburZrlOWZziStT",
        },
        {
          label: "مدیریت کامنت ها",
          key: "oJaqaTGOeQmSe3j",
        },
        {
          label: "مشکلات کاربران",
          key: "YToQKzPBaLf4gHX",
        },
      ],
    },
  ];
  return (
    <BoxShadow style={{ padding: "10px", marginTop: "10px" }}>
      <div className="col-md-9">
        <div className="row">
          <div className="col">
            <h4 style={{}}>تعیین دسترسی</h4>
          </div>
        </div>
        <div className="row">
          {routes.map((route, index) => {
            if (route.type == slug.split("-")[1]) {
              return (
                <div className="col-12">
                  <h2>{route.label}</h2>
                  <div className="row">
                    {route.routes.map((subRoute, index) => {
                      return (
                        <div key={index} className="col-md-4">
                          <FormGroup>
                            <FormControlLabel
                              style={{ fontSize: "12px" }}
                              onChange={() => {
                                toggle(subRoute);
                              }}
                              control={<Switch />}
                              label={subRoute.label}
                              checked={isIn(subRoute)}
                            />
                          </FormGroup>
                        </div>
                      );
                    })}
                  </div>
                </div>
              );
            }
          })}
          <button className="btn btn-danger " onClick={() => {}}>
            ثبت
          </button>
        </div>
      </div>
    </BoxShadow>
  );
};

export default EditRole;
